/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PinnedArtifactsRequest {
    getFixupPrototypeFunction() { return PinnedArtifactsRequest.fixupPrototype; }

    static newInstance(model: Partial<PinnedArtifactsRequest>): PinnedArtifactsRequest {
        let obj = Object.assign(new PinnedArtifactsRequest(), model);
        PinnedArtifactsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PinnedArtifactsRequest>): PinnedArtifactsRequest {
        if (!model) return null;
        return PinnedArtifactsRequest.newInstance(<PinnedArtifactsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PinnedArtifactsRequest) {
        if (!obj) return;

        models.PinnedArtifactsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PinnedArtifactsRequest): boolean {
        Object.setPrototypeOf(obj, PinnedArtifactsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * ID of the agent
     */
    agent_id: string;

}
